'use es6';

export const CHANGE_EXPANDED_STATE = 'change-expand';
export const EXPAND = 'expand';
export const FOCUS = 'focus';
export const HIDE = 'hide';
export const LOAD_SURVEY = 'load-survey';
export const LOCATION_CHANGE = 'location-change';
export const PREVIEW = 'preview';
export const READY = 'ready';
export const RESET = 'reset';
export const RESIZE_POPUP = 'resize-popup';
export const SETUP = 'setup';
export const SHOW = 'show';
export const STAGE_CHANGE = 'stage-change';
export const SURVEY_FETCHED = 'fetched';
export const UPDATE = 'update';
export const LOAD_CONFIG_ONLY = 'load-config-only';
export const CONFIG_FETCHED = 'config-fetched';
export const SHOW_LOADED_CONFIG = 'show-loaded-config';

// preview only
export const CHANGE_STATE = 'CHANGE_STATE';
export const UPDATE_PREVIEW = 'UPDATE_PREVIEW';